import React, { useState, useEffect } from 'react'
import './index.css'
import { AxiosResponse } from "axios";
import api from '../../Services/api'
import ModalPrincipal from '../ModalAlert/modal'
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import { useNavigate } from 'react-router';
import CustomRegistrationModalShell from '../CustomRegistrationForm/CustomRegistrationModalShell'
import ActiveToggleField from '../CustomRegistrationForm/ActiveToggleField'
import '../CustomRegistrationForm/custom-registration-modal.css'
import '../TaskForm/usuario-form.css'

function FormTaskGroup(props: any) {

    const navigate = useNavigate();

    const dadosEquipe = (sessionStorage.getItem("dadosTipoEquipe") || '{}');
    let userEqp = JSON.parse(dadosEquipe);

    const [openModal, setOpenModal] = useState(false)
    const [qualAlert, setQualAlert] = useState(<></>)

    const [id, setId] = useState(userEqp.tgp_id || '')
    const [active, setActive] = useState(userEqp.tgp_active != undefined ? Boolean(userEqp.tgp_active) : true)
    const [description, setDescription] = useState(userEqp.tgp_description || '')
    const [alternativeIdentifier, setAlternativeIdentifier] = useState(userEqp.tgp_integrationid || '')
    const [descriptionIni, setDescriptionIni] = useState(userEqp.tgp_description || '')
    const [alternativeIdentifierIni, setAlternativeIdentifierIni] = useState(userEqp.tgp_integrationid || '')

    const [optionstaskgroup, setOptionstaskgroup] = useState([])


    useEffect(() => {

        validatToken();

    }, []);

    async function validatToken() {

        let ret: AxiosResponse;
        let valor: any;


        const _user = secureLocalStorage.getItem('t')

        api.defaults.headers.common['Authorization'] = _user as ''

        try {

            ret = await api.get("/status/validar")

            if (ret.data.status === 200) {

                secureLocalStorage.setItem('t', ret.data.data);
                secureLocalStorage.setItem('acp', ret.data.decodedToken.acp_integrationid);
                secureLocalStorage.setItem('n', ret.data.decodedToken.name);
                secureLocalStorage.setItem('iag', ret.data.decodedToken.id);
                secureLocalStorage.setItem('cy', ret.data.decodedToken.company);
                GetTaskgroup();
                setOpenModal(false)
            }

        } catch (e: any) {

            if (e.response.data.status === 403) {

                setQualAlert(<div className='div-alert'>
                    <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                    <div className='div-info-alert'><span className="info-alert">Token inválido ou expirado!</span></div>
                    <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                </div>)

                setOpenModal(true)

            }else{
                setOpenModal(false)
            }
        }

    }

    function fecharModal() {

        secureLocalStorage.removeItem('t')
        secureLocalStorage.removeItem('acp')
        secureLocalStorage.removeItem('n')
        secureLocalStorage.removeItem('iag')
        navigate('/login');
        setOpenModal(false)

    }

    async function GetTaskgroup() {

        let ret: AxiosResponse;
        let valor: any;
        try {
            ret = await api.get("taskgroup/verificacao")
            if (ret.data.status === 200) {
                valor = ret.data.data;

                setOptionstaskgroup(valor)

            }
        } catch (e) {
            setOptionstaskgroup([])
        }
    }

    async function ConfirmarTeamtype() {

        let ret: AxiosResponse;
        let valor: any;

        const _user = secureLocalStorage.getItem('t')


        api.defaults.headers.common['Authorization'] = _user as ''

        try {

            ret = await api.get("/status/validar")

            if (ret.data.status === 200) {

                if (id === undefined || id === '') {

                    insertTipoAgente();

                } else {

                    UpdatgpipoAgente();

                }
            }

        } catch (e: any) {

            if (e.response.data.status === 403) {

                setQualAlert(<div className='div-alert'>
                    <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                    <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                    <div className='div-info-alert'><span className="info-alert">Token inválido ou expirado!</span></div>
                    <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                </div>)

                setOpenModal(true)

            }
        }
    }

    async function UpdatgpipoAgente() {
        let ret: AxiosResponse;


        setQualAlert(<div className='div-alert'><Loading /></div>)
        setOpenModal(true)

        const Filtrardescription = optionstaskgroup.filter(
            (e: any) => {
                return e.tgp_description.toLowerCase() === description.toLowerCase()
            }
        );

        const FiltraralternativeIdentifier = optionstaskgroup.filter(
            (e: any) => {
                return e.tgp_integrationid.toLowerCase() === alternativeIdentifier.toLowerCase()
            }
        );

        if (descriptionIni.toLowerCase() !== description.toLowerCase() && Filtrardescription.length > 0) {

            setQualAlert(<div className='div-alert'>
                <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                <div className='div-info-alert'><span className="info-alert">A descrição já está em uso.</span></div>
                <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
            </div>)


        } else
            if (alternativeIdentifierIni.toLowerCase() !== alternativeIdentifier.toLowerCase() && FiltraralternativeIdentifier.length > 0) {

                setQualAlert(<div className='div-alert'>
                    <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                    <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                    <div className='div-info-alert'><span className="info-alert">O identificador alternativo já está em uso.</span></div>
                    <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
                </div>)

            } else

                if (description === "") {
                    setQualAlert(<div className='div-alert'>
                        <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                        <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                        <div className='div-info-alert'><span className="info-alert">Digite a descrição.</span></div>
                        <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
                    </div>)
                } else
                    if (alternativeIdentifier === "") {
                        setQualAlert(<div className='div-alert'>
                            <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                            <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                            <div className='div-info-alert'><span className="info-alert">Digite o identificador alternativo.</span></div>
                            <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
                        </div>)
                    } else {

                        const dados = {
                            tgp_id: id,
                            tgp_active: active,
                            tgp_description: description,
                            tgp_integrationid: alternativeIdentifier,
                        }
                        try {
                            ret = await api.put("taskgroup/update", {
                                data: dados,
                            });
                            if (ret.data.status === 200) {
                                props.voltar()
                            }
                        } catch (e: any) {

                            setQualAlert(<div className='div-alert'>
                                <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                                <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                                <div className='div-info-alert'><span className="info-alert">Não foi possível concluir a alteração.</span></div>
                                <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
                            </div>)

                        }
                    }
    }

    async function insertTipoAgente() {
        let ret: AxiosResponse;

        setQualAlert(<div className='div-alert'><Loading /></div>)
        setOpenModal(true)

        const Filtrardescription = optionstaskgroup.filter(
            (e: any) => {
                return e.tgp_description.toLowerCase() === description.toLowerCase()
            }
        );

        const FiltraralternativeIdentifier = optionstaskgroup.filter(
            (e: any) => {
                return e.tgp_integrationid.toLowerCase() === alternativeIdentifier.toLowerCase()
            }
        );

        if (Filtrardescription.length > 0) {

            setQualAlert(<div className='div-alert'>
                <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                <div className='div-info-alert'><span className="info-alert">A descrição já está em uso.</span></div>
                <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
            </div>)


        } else
            if (FiltraralternativeIdentifier.length > 0) {

                setQualAlert(<div className='div-alert'>
                    <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                    <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                    <div className='div-info-alert'><span className="info-alert">O identificador alternativo já está em uso.</span></div>
                    <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
                </div>)

            } else

                if (description === "") {
                    setQualAlert(<div className='div-alert'>
                        <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                        <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                        <div className='div-info-alert'><span className="info-alert">Digite a descrição.</span></div>
                        <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
                    </div>)
                } else
                    if (alternativeIdentifier === "") {
                        setQualAlert(<div className='div-alert'>
                            <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                            <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                            <div className='div-info-alert'><span className="info-alert">Digite o identificador alternativo.</span></div>
                            <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
                        </div>)
                    } else {


                        const dados = [{
                            tgp_active: active,
                            tgp_description: description,
                            tgp_integrationid: alternativeIdentifier,
                        }]

                        try {
                            ret = await api.post("taskgroup/insert", {
                                data: dados,
                            });

                            if (ret.data.status === 200) {
                                props.voltar()
                            }
                        } catch (e: any) {

                            setQualAlert(<div className='div-alert'>
                                <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                                <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                                <div className='div-info-alert'><span className="info-alert">Não foi possível concluir o cadastramento.</span></div>
                                <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
                            </div>)
                        }

                    }

    }

    function finalizarModal2() {
        setOpenModal(false)
    }

    function ValitarActive() {
        let e = document.getElementById("checkbox-taksgrupo") as HTMLInputElement;

        if (e.checked) {

            setActive(true)
        } else {

            setActive(false)
        }
    }

    function voltar() {

        props.voltar();

    }

    return (
        <>
            <CustomRegistrationModalShell
                mode={id ? 'edit' : 'add'}
                recordId={id ? String(id) : undefined}
                title={id ? 'Editar grupo da tarefa' : 'Cadastrar grupo da tarefa'}
                subtitle="Agrupa tipos de tarefa no planejamento e no aplicativo mobile."
                onCancel={props.voltar}
                onSave={ConfirmarTeamtype}
            >
                <ActiveToggleField active={active} onChange={setActive} />

                <div className="usuario-form__grid usuario-form__grid--2">
                    <div className="usuario-form__field">
                        <label className="usuario-form__label usuario-form__label--required">Descrição</label>
                        <input
                            className="usuario-form__input"
                            type="text"
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                            autoComplete="off"
                        />
                    </div>
                    <div className="usuario-form__field">
                        <label className="usuario-form__label usuario-form__label--required">
                            Identificador Alternativo
                        </label>
                        <input
                            className="usuario-form__input"
                            autoComplete="off"
                            type="text"
                            onChange={(e) => setAlternativeIdentifier(e.target.value)}
                            value={alternativeIdentifier}
                        />
                    </div>
                </div>
            </CustomRegistrationModalShell>

            <ModalPrincipal isOpen={openModal} setModalOpen={() => setOpenModal(!openModal)}>
                <div className='container-modal-alert'>
                    {qualAlert}
                </div>
            </ModalPrincipal>
        </>
    );

}

export default FormTaskGroup;